import _ from 'lodash';

import store from '@/store';
import router from '@/router';

const currentUser = () => {
  return store.getters['app/activeUser'];
};

const permissions = () => {
  return store.getters['app/permissions'];
};

const currentSite = () => {
  return store.getters['app/activeSite'];
};

const isAdminView = () => {
  return _.get(router, 'history.current.meta.isAdmin');
};

// HACK
// selects the first non-site group it finds -- need to be fixed if we want more complex permissions
const adminGroup = () => {
  const permission = _.find(permissions(), { group: { type: 'chemical-manufacturers' } });
  return _.get(permission, 'group.id');
};

const canDo = (model, action, forceAdminPermissionCheck) => {
  if (!currentUser()) {
    return false;
  }
  if (currentUser().isSuperUser) {
    return true;
  }

  let id;
  let type;
  if (isAdminView() || forceAdminPermissionCheck) {
    type = 'chemical-manufacturers';
    id = adminGroup();
  } else {
    type = 'sites';
    id = currentSite();
  }

  return (
    _.some(permissions(), { model, action, group: { id, type } }) ||
    _.some(permissions(), {
      model,
      action,
      group: { id: adminGroup(), type: 'chemical-manufacturers' },
    })
  );
};

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    if (store.getters['app/activeUser']) {
      if (canDo('ALXAdminMenu', 'show')) {
        next('/admin/dashboard');
      } else if (store.getters['app/activeSite']) {
        next(`/sites/${store.getters['app/activeSite']}/dashboard`);
      }
    }
    return next();
  }
  if (to.path === '/' || !store.getters['app/activeUser']) {
    return next('/login');
  }

  return next();
});

export default canDo;
